import { useQuery } from "@tanstack/react-query";
import { getPublicAuthHeader, getReturnWidgetBaseUrl } from "./return-widget-client";

export type PublicProductRecommendation = {
  targetProductId: string;
  targetProductTitle: string | null;
  targetImageUrl: string | null;
  targetHandle: string | null;
  rankingScore: number;
};

export function usePublicProductRecommendations(
  shopId: string,
  productId: string | null | undefined,
) {
  return useQuery<PublicProductRecommendation[]>({
    queryKey: ["public-product-recommendations", shopId, productId],
    queryFn: async () => {
      const base = getReturnWidgetBaseUrl().replace(/\/$/, "");
      const url = new URL(`${base}/public/product-recommendations`);
      url.searchParams.set("shopId", shopId);
      url.searchParams.set("productId", productId!);
      const res = await fetch(url.toString(), { headers: getPublicAuthHeader() });
      if (!res.ok) throw new Error(`product-recommendations ${res.status}`);
      return res.json() as Promise<PublicProductRecommendation[]>;
    },
    enabled: !!shopId && !!productId,
    staleTime: 5 * 60 * 1000,
  });
}
